import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { IconButton, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { LogoImageBox } from './style';
import { BottomMenu, RenderMenu2 } from './Nav';
import { useLocation } from 'react-router-dom';

export default function ResponsiveNav({displayDetails}) {
    const [open, setOpen] = React.useState(false);

    const theme = useTheme();
    const location = useLocation();
    const isMobileView = useMediaQuery(theme.breakpoints.down('md'));
    const isMailPage = location.pathname === '/mail';

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    React.useEffect(() => {
        // if ((isMailPage && isMobileView)|| open) {
        if (isMailPage && isMobileView) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [isMailPage, isMobileView, open]);

    const DrawerList = (
        <Box
            sx={{
                width: 250,
                height: '100%',
                paddingLeft: '8px',
                paddingRight: '8px',
                paddingBottom: '20px',
            }}
            role="presentation"
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
        >
            <Box>
                <LogoImageBox sx={{ padding: '20px 14px' }}>
                    <img src="/images/logo/logoMobile.png" height={30} width={90} alt="Logo" />
                </LogoImageBox>
                <RenderMenu2 displayDetails={displayDetails}/>
            </Box>
            <Box>
                <BottomMenu />
            </Box>
        </Box>
    );

    return (
        <>
            <IconButton
                size="medium"
                color="inherit"
                aria-label="menu"
                sx={{
                    display: {
                        sm: 'none',
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '1.5rem',
                    },
                }}
                onClick={toggleDrawer(true)}
            >
                <MenuIcon />
            </IconButton>
            <Drawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
            </Drawer>
        </>
    );
}
